var socialComponent = (function () {
    function socialComponent() {
    }
    socialComponent.prototype.ngOnInit = function () { };
    /**
     * When the focus of the tab group changes
     * store the index of the current selected
     * tab to currentIndex
     * @param event mdTabChange event
     */
    socialComponent.prototype.focusChanged = function (event) {
        this.currentIndex = event.index;
    };
    return socialComponent;
}());
export { socialComponent };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/socialComponent/social.component.ts.pre-build-optimizer.js